import React from "react";
import Style from "styles/components/top_case_study.module.scss";
import classNames from 'classnames';
import {Link} from 'gatsby';

const convert2PlainText = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const plainText = div.textContent || div.innerText || '';
  return plainText;
}

const TopCaseStudyCard = ({ id, thmImageSrc, storeLogo, storeName, customerName, content }) => {
  return (
    <div className={classNames(Style.caseStudyCard__container)}>
      <Link to={`/case_study_detail/?id=${id}`}>
        <div className={classNames(Style.caseStudyCard__container__head)}>
          <img src={storeLogo} className={classNames(Style.caseStudyCard__container__head__storeLogo)} alt="店舗ロゴ" />
          <div className={classNames(Style.caseStudyCard__container__head__labels)}>
            <div className={classNames(Style.caseStudyCard__container__head__labels__storeName)}>
              {storeName}
            </div>
            <div className={classNames(Style.caseStudyCard__container__head__labels__customerName)}>
              {customerName}
            </div>
          </div>
        </div>
        <div className={classNames(Style.caseStudyCard__container__thumbnailImage)}>
          <img src={thmImageSrc} alt="サムネイル画像" />
        </div>
        <div className={classNames(Style.caseStudyCard__container__content)}>
          {convert2PlainText(content)}
        </div>
      </Link>
    </div>
  );
};

export default TopCaseStudyCard;
